export default function getAuthors(authors = []) {
    if (authors.length > 0) {
        const emails = [];
        authors.forEach((author) => {
            const emailIndex = author.contacts.findIndex(({ type = '' }) => type === 'email');

            if (emailIndex > -1) {
                emails.push(author.contacts[emailIndex].value);
            }
        });

        return emails;
    }

    return [];
}



/** WEBPACK FOOTER **
 ** ./src/utils/get-authors.js
 **/